import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';

export interface Contact {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  notify: boolean;
}

@Component({
  selector: 'app-notifications-dialog',
  host: {
    "[style.width]": "'100%'",
    "[style.min-width]": "'700px'",
    "[style.height]": "'100%'",
  },
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss']
})
export class NotificationsDialogComponent implements OnInit {

  firstNameFormControl = new FormControl('', [
    Validators.required
  ]);

  lastNameFormControl = new FormControl('', [
    Validators.required
  ]);

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  phoneFormControl = new FormControl('', [
    Validators.required
  ]);

  addContactMode: boolean = false;

  contacts: Contact[] = [
    {
      firstName: 'Kyle',
      lastName: 'Hall',
      email: "khall@flashgate.ca",
      phone: "604-555-5555",
      notify: true
    },
    {
      firstName: 'Tim',
      lastName: 'Robertson',
      email: "trobertson@flashgate.ca",
      phone: "604-555-5555",
      notify: false
    },
    {
      firstName: 'Shawn',
      lastName: 'Wang',
      email: "buyingporsche944@gmail.com",
      phone: "604-555-5555",
      notify: true
    }
  ];

  constructor(public dialogRef: MatDialogRef<NotificationsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.resetInput();
  }

  ngOnInit() {

  }

  onNewContactClick() {
    this.addContactMode = true;
  }

  onAddContactClick() {

    let newContact = {
      firstName: this.getProperNameCasing(this.firstNameFormControl.value),
      lastName: this.getProperNameCasing(this.lastNameFormControl.value),
      email: this.emailFormControl.value.toLowerCase(),
      phone: this.phoneFormControl.value,
      notify: true
    };

    this.addContact(newContact);

    this.addContactMode = false;
    this.resetInput();
  }

  onCancelAddContactClick() {
    this.addContactMode = false;
    this.resetInput();
  }

  resetInput() {
    this.firstNameFormControl.reset();
    this.lastNameFormControl.reset();
    this.emailFormControl.reset();
    this.phoneFormControl.reset();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  addContact(contact: Contact) {
    //TODO call API
    this.contacts.push(contact);
  }

  removeContact(contact: Contact) {
    //TODO call api
    console.log("removing: ", contact);


    let index = this.contacts.indexOf(contact);
    if(index !== -1) {
      this.contacts.splice(index, 1);
    }
  }

  getProperNameCasing(name: string): string {
    return name.charAt(0).toUpperCase() + name.substr(1).toLowerCase();
  }
}
